<form [formGroup]="form">
  <div formArrayName="phoneNumbers">
    <div *ngFor="let phoneNumber of phoneNumbers.controls; let i = index" [formGroupName]="i">
      <div class="flex flex-wrap items-start gap-4">
        <!-- Préfixe -->
        <base-form-input
          class="flex-1 min-w-[250px]"
          label="Préfixe"
          type="select"
          [items]="prefixes"
          [displayProperty]="'displayLabel'"
          [formGroup]="getPhoneNumberFormGroup(i)"
          controlName="prefix"
        ></base-form-input>

        <!-- Numéro de téléphone -->
        <div class="flex-[2] min-w-[300px]">
          <base-form-input
            [label]="isOtherPrefix(i) ? 'Numéro (saisie libre)' : 'N° de téléphone'"
            [placeholder]="isOtherPrefix(i) ? 'Ex: 0800123456, 3615, 15...' : ''"
            [formGroup]="getPhoneNumberFormGroup(i)"
            controlName="phoneNumber"
          ></base-form-input>

          <mat-error
            *ngIf="
              getPhoneNumberFormGroup(i).get('phoneNumber')?.hasError('invalidPhoneNumber') &&
              getPhoneNumberFormGroup(i).get('phoneNumber')?.touched
            "
            style="font-size: 75%; margin-top: -20px"
          >
            <span *ngIf="!isOtherPrefix(i)">Le numéro de téléphone est invalide pour ce pays</span>
          </mat-error>
        </div>

        <!-- Bouton de suppression -->
        <div class="flex items-center pt-3">
          <button type="button" mat-icon-button color="warn" (click)="removePhoneNumber(i)">
            <mat-icon>cancel</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="mt-4">
    <button type="button" mat-raised-button color="primary" (click)="addPhoneNumber()" class="add-phone-number-button">
      <mat-icon class="add-icon">add</mat-icon>
      Ajouter un numéro de téléphone
    </button>
  </div>
</form>
